const {useState, useCallback} = require('react');

export function useInputValue({init} = {}) {
	const [val, setVal] = useState(init)
	const onChange = useCallback(e => {setVal(e.target.value)}, [])
	return {inputProps: {value: val, onChange}}
}